export default {"src":"/_next/static/media/features-unlimited-email-masks.44e23610.svg","height":370,"width":406,"blurWidth":0,"blurHeight":0};